import { render } from "./CardAddIcon.vue?vue&type=template&id=349a2cb6"
import script from "./CardAddIcon.vue?vue&type=script&lang=js"
export * from "./CardAddIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__